import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { createInfoBindKey } from '../queries/useInfoBinds';

const addBinds = async (values) => {
  const data = await request.post(
    `/Information/bind`,
    values,
    'Не удалось создать привязку',
    'Error'
  );

  return data;
};

const useAddBinds = () => {
  const queryClient = useQueryClient();

  const addMutation = useMutation(({ values }) => addBinds(values), {
    onSuccess: async (data, { values }) => {
      if (data?.result === 'Ok') {
        queryClient.invalidateQueries(createInfoBindKey(values.infoId));
      }
    },
  });

  const addMutateAsync = (values) => addMutation.mutateAsync({ values });

  return {
    addBinds: addMutateAsync,
    loading: addMutation.isLoading,
  };
};

export default useAddBinds;
